<template>
  <div
    class="save-current-spot scurrs"
    :class="[{ 'no-events': saving || saved }, { scurrs_saved: saved }]"
    style="grid-gap: 0.5rem"
    @keydown.enter="save"
  >
    <div class="weight_700 text-large d-flex">
      {{ $t('common.current_spot') }}
    </div>

    <div
      class="d-flex f-wrap"
      style="grid-gap: 0.5rem"
    >
      <div class="scurrs_box">
        <div class="scurrs_title">
          {{ currentSpot.custom_solution_id ? $t('common.custom_solution') : $t('common.format') }}
        </div>

        <CustomFormatOption
          v-if="currentSpot.custom_solution_id"
          :customTree="solElite.cTree"
        />
        <GameformatOption
          v-else
          class="weight_700"
          :customItem="getGameformat(currentSpot)"
        />
      </div>

      <div class="scurrs_box">
        <div class="scurrs_title">
          {{ $t('table_head.board') }}
        </div>

        <div class="d-flex no-events">
          <PokerCard
            v-for="(card, idx) in getBoardCards(currentSpot.board)"
            :key="`${idx}_${card}`"
            :disabled="true"
            :small="true"
            size="small"
            :card="card"
          ></PokerCard>
        </div>
      </div>

      <div class="scurrs_box">
        <div class="scurrs_title">
          {{ $t('common.actions') }}
        </div>
        <StreetActionsCompacted
          class="f-wrap"
          :streets="getStreetsActions(currentSpot)"
        />
      </div>
    </div>

    <div class="scurrs_box">
      <div
        class="gw_input_wrapper"
        :class="{ gw_input_error: note.length > 500 }"
      >
        <div class="gw_input_label">
          {{ $t('common.note') }}
        </div>
        <textarea
          ref="note"
          v-model="note"
          :placeholder="$t('messages.save_spot_note_placeholder')"
          contenteditable="true"
          class="textarea_note"
          style="--input-height: 8rem"
          @keydown.stop.enter.exact.prevent="save()"
          @keydown.stop.enter.shift.exact.prevent="note += '\n'"
        ></textarea>
        <div class="gw_input_error_message">
          {{
            $t(`messages.note_too_many_characters`, {
              max_chars: 500,
            })
          }}
        </div>
      </div>
    </div>
    <v-btn
      color="primary"
      class="ml-auto"
      @click="save"
    >
      <v-icon class="mr-2">mdi-content-save</v-icon>
      {{ $t('btn.save') }}
    </v-btn>

    <div class="bb-grey mt-12"></div>
  </div>
</template>

<script>
import CustomFormatOption from '@/components/GameFormat/CustomFormatOption'
import StreetActionsCompacted from '@/components/StreetActionsCompacted/StreetActionsCompacted'
import PokerCard from '@/components/Poker/PokerCard/PokerCard'
import GameformatOption from '@/components/GameFormat/GameFormatOption'
import format_mix from '@/mixins/format_mix'
import { getGameformat } from '@/store/gameformat/gameformat'
import { SNK } from '@/helpers/helpers'
import { namespaces } from '@/helpers/constants'

export default {
  name: 'SaveCurrentSpot',
  components: {
    GameformatOption,
    CustomFormatOption,
    StreetActionsCompacted,
    PokerCard,
  },
  mixins: [format_mix],
  props: {
    dialog: Object,
    namespace: { required: true, type: String },
  },
  data() {
    return {
      note: '',
      saving: false,
      saved: false,
    }
  },
  mounted() {
    const { textarea } = this.$refs
    if (textarea) {
      textarea.focus()
    }
  },
  methods: {
    getBoardCards(str) {
      const board = this.getCards(str)
      const res = [...board, 'Ee', 'Ee', 'Ee', 'Ee', 'Ee', 'Ee'].slice(0, 5)
      return res
    },
    save() {
      if (this.note.length > 500) return
      if (this.saving) {
        return
      }
      this.saving = true
      this.$store.dispatch('api_call', {
        method: 'POST',
        hasCancel: false,
        endpoint: `poker/saved-spots/`,
        data: this.currentSpot,
        message: {
          type: 'error',
        },
        fn: result => {
          this.saving = false
          if (!result.error) {
            this.$store.dispatch('globals_action', 'SavedSpotsTable')
            this.saved = true
          }
        },
      })
    },
    getGameformat(item) {
      const { gameformats } = this.$store.getters
      const res = getGameformat({ item, gameformats })
      return res
    },
    getStreetsActions(item) {
      const res = {
        preflop_actions: item.preflop_actions ? item.preflop_actions.split('-') : [],
        flop_actions: item.flop_actions ? item.flop_actions.split('-') : [],
        turn_actions: item.turn_actions ? item.turn_actions.split('-') : [],
        river_actions: item.river_actions ? item.river_actions.split('-') : [],
      }
      // console.log(res, item)
      return res
    },
  },
  computed: {
    solElite() {
      return this.$store.getters[SNK('sol_elite', this.namespace)]
    },
    currentSpot() {
      const query_history = this.$store.getters[SNK('query_history', this.namespace)]
      const history_spot = this.$store.getters[SNK('history_spot', this.namespace)]
      const query_board = this.$store.getters[SNK('query_board', this.namespace)]
      const qh = query_history
      const hSpot = history_spot
      // console.log(hSpot)
      const gmfQuery = hSpot.custom_solution_id
        ? {
            custom_solution_id: hSpot.custom_solution_id,
            board: hSpot.board,
          }
        : {
            gametype: qh.gametype,
            depth: qh.depth,
            stacks: qh.stacks,
            board: query_board,
          }
      const res = {
        ...gmfQuery,
        preflop_actions: qh.preflop_actions,
        flop_actions: qh.flop_actions,
        turn_actions: qh.turn_actions,
        river_actions: qh.river_actions,
        history_spot: qh.history_spot ? qh.history_spot : 0,
        note: this.note.trim(),
        marked: false,
      }
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.save-current-spot {
  display: flex;
  flex-direction: column;
}
.scurrs {
  max-height: 520px;
  transition: 0.2s;
  &_saved {
    opacity: 0;
    max-height: 0px;
    overflow: hidden;
    margin-bottom: 0 !important;
  }
  &_title {
    font-weight: 500;
    color: var(--clr-grey-2);
    font-size: 0.8rem;
    padding: 0 0 0.25rem 0;
  }
  &_box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 0.5rem 1rem 0.5rem 1rem;
    background: var(--clr-black-1);
    border-radius: 4px;
  }
}
</style>
